import moment from "moment";
import { useParams } from "react-router";
import { kFormatter } from "helpers/utility/formatters";
import { useDatasetVersion } from "helpers/utility/utilities";
import styles from "./style.module.scss";
import classNames from "classnames";
import { useCamtekMetadata } from "./useCamtekMetadata";

interface DescriptionListProps {
  dataset: any;
  showJobSetupRecipe?: boolean;
  showDatasetInfo?: boolean;
  className?: string;
  mode?: "vertical" | "horizontal";
}

const DescriptionListForDataPage = ({
  dataset,
  sourceName,
  imageCount,
  sizeValue,
  createdAt,
  creatorName,
  dsVersion,
  showJobSetupRecipe,
  showDatasetInfo,
  mode,
}: any) => {
  const { datasetId, clusterId, imageId } = useParams();
  const isImagePage = !!imageId && !!datasetId && !clusterId;
  const showSource = isImagePage;
  const showSize = !!sizeValue;
  const showCreatedAt = !!createdAt;
  const showCreatedBy = !!creatorName;
  const showDsVersion = !!dsVersion;

  const { getCamtekMetadata, hasJobSetupRecipeMetadata } =
    useCamtekMetadata(dataset);

  const formatValue = (value: number) => {
    return kFormatter(value).toUpperCase();
  };

  const renderDescription = (title: string, description: string) => (
    <div className={styles.contentLeftBox}>
      <span className={styles.title}>{title}&nbsp;</span>
      <span className={styles.description}>{description}</span>
    </div>
  );

  const renderDescriptionBoxes = () => (
    <div
      className={classNames(styles.innerHeaderContentLeft, {
        [styles.vertical]: mode === "vertical",
      })}
    >
      {showDatasetInfo && (
        <>
          {showSource && renderDescription("Source", sourceName)}
          {renderDescription("Images", formatValue(imageCount))}
          {/*{renderDescription("Objects", formatValue(objectCount))}*/}
          {/*{renderDescription("Videos", formatValue(videoCount))}*/}
          {/*{renderDescription("Video Frames", formatValue(frameCount))}*/}
          {showSize && renderDescription("Size", sizeValue)}
          {showCreatedAt &&
            renderDescription(
              "Created",
              moment.utc(createdAt).local().fromNow(),
            )}
          {showCreatedBy && renderDescription("Created By", creatorName)}
          {showDsVersion && renderDescription("Version", dsVersion)}
        </>
      )}
      {showJobSetupRecipe && (
        <>
          {showDatasetInfo && hasJobSetupRecipeMetadata && (
            <div className={styles.divider} />
          )}
          {getCamtekMetadata("Job Name") &&
            renderDescription("Job Name", getCamtekMetadata("Job Name"))}
          {getCamtekMetadata("Setup Name") &&
            renderDescription("Setup Name", getCamtekMetadata("Setup Name"))}
          {getCamtekMetadata("Recipes Name") &&
            renderDescription(
              "Recipes Name",
              getCamtekMetadata("Recipes Name"),
            )}
        </>
      )}
    </div>
  );

  return renderDescriptionBoxes();
};

const DescriptionList = ({
  dataset,
  showJobSetupRecipe = false,
  showDatasetInfo = true,
  className,
  mode = "horizontal",
}: DescriptionListProps) => {
  const dsVersion = useDatasetVersion(dataset?.pipeline_commit_id);
  return (
    <div className={styles.innerHeaderContent}>
      <DescriptionListForDataPage
        className={className}
        dataset={dataset}
        sourceName={dataset?.source_type}
        imageCount={dataset?.n_images}
        sizeValue={dataset?.size_display_value}
        createdAt={dataset?.created_at}
        creatorName={dataset?.creator_name}
        dsVersion={dsVersion}
        showJobSetupRecipe={showJobSetupRecipe}
        showDatasetInfo={showDatasetInfo}
        mode={mode}
      />
    </div>
  );
};

export default DescriptionList;
